import SEO from "@/components/common/SEO";
import { Link } from "react-router-dom";
import { Home, Search, ArrowLeft } from "lucide-react";

import { organizationSchema } from "../components/common/schema";

const schemas = [
  organizationSchema(),
];

export default function NotFound() {
  return (
    <>
      <SEO
        title="404 - Page Not Found"
        description="The page you are looking for does not exist."
        canonical={null}
        robots="noindex, nofollow"
        structuredData={schemas}
      />
      <section className="min-h-[80vh] flex items-center justify-center bg-background px-6 py-20">
        <div className="max-w-2xl text-center">
          <p className="text-primary text-lg font-semibold mb-2">404 Error</p>

          <h1 className="text-5xl md:text-6xl font-bold tracking-tight text-foreground">
            Page Not Found
          </h1>

          <p className="mt-6 text-lg text-muted-foreground leading-8">
            Sorry, the page you're looking for doesn't exist, may have been
            moved, or the URL may be incorrect.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-6 py-3 text-primary-foreground font-medium transition hover:opacity-90"
            >
              <Home size={18} />
              Go to Homepage
            </Link>

            <Link
              to="/calculators"
              className="inline-flex items-center justify-center gap-2 rounded-lg border border-border bg-background px-6 py-3 font-medium transition hover:bg-muted"
            >
              <Search size={18} />
              Loan Calculators
            </Link>
          </div>

          <div className="mt-10">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition"
            >
              <ArrowLeft size={16} />
              Go Back
            </button>
          </div>

          <div className="mt-14 rounded-xl border border-border bg-muted/30 p-6">
            <h2 className="font-semibold text-lg">
              Need help finding the right page?
            </h2>

            <p className="mt-2 text-muted-foreground">
              Contact our loan advisors and we'll be happy to assist you.
            </p>

            <div className="mt-6 space-y-2 text-sm">
              <p>
                <strong>Phone:</strong>{" "}
                <a
                  href="tel:+919214417434"
                  className="text-primary hover:underline"
                >
                  +91-9214417434
                </a>
              </p>

              <p>
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:contact@money-mart.in"
                  className="text-primary hover:underline"
                >
                  contact@money-mart.in
                </a>
              </p>

              <p>
                <strong>Office Hours:</strong> Monday – Saturday, 10:00 AM –
                7:00 PM
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
